// The public address of Stew. Links we hand out (shared songs and albums, the Discord activity) always use
// it, whatever address the app happens to be opened from (the Firebase address, a local dev server, …).
export const SITE_ORIGIN = 'https://stewsocial.com';

export const siteUrl = (path = '') => `${SITE_ORIGIN}${path}`;
